/**
 * @ngdoc service
 * @name common.newsletter.service:ItxNewsletterSvc
 * @requires $q
 * @description
 * Newsletter service
 */
(function () {
    'use strict';

    angular.module('itxApp.common').service('ItxNewsletterSvc', ItxNewsletterSvc);

    ItxNewsletterSvc.$inject = [
        '$q',
        '$http',
        'ItxTranslateSvc',
        'UserService',
        'timestampSvc',
        'DialogSvc',
        'imNewsletter'
    ];

    function ItxNewsletterSvc(
        $q,
        $http,
        ItxTranslateSvc,
        UserService,
        timestampSvc,
        DialogSvc,
        imNewsletter
    ) {
        var _this = this;

        var sectionsAllowed = ['NEWSLETTER_WOMAN', 'NEWSLETTER_MAN'];
        var DEFAULT_NEWSLETTER = 'NEWSLETTER_WOMAN#NEWSLETTER_MAN';

        _this.initialized = false;

        _this.sections = [];

        _this.optIn = false;

        var service = {
            getConfiguration: getConfiguration,
            subscribe: subscribe,
            unsubscribe: unsubscribe,
            sendUnsubscribeNewsletterSurvey: sendUnsubscribeNewsletterSurvey,
            getSurveyTemplate: getSurveyTemplate,
            shuffleOptions: shuffleOptions,
            getStatus: getStatus,
            updateSections: updateSections,
            generalNewsletter: DEFAULT_NEWSLETTER,
            getOptin: getOptin
        };
        return service;

        function getOptin() {
            var deferred = $q.defer();
            if (_this.optIn) {
                deferred.resolve(_this.optIn);
            } else {
                inditex.getXconfiguracionValue('NEWSLETTER_DOUBLE_OPT_IN', function (
                    status,
                    value
                ) {
                    if (value === '1') {
                        _this.optIn = true;
                        deferred.resolve(_this.optIn);
                    }
                });
            }
            return deferred.promise;
        }
        /**
         * @ngdoc method
         * @name getConfiguration
         * @methodOf common.newsletter.service:ItxNewsletterSvc
         * @description
         *
         * Get configuration values from Xconfiguration.
         * ENABLED_NEWSLETTER_BOYS_AND_GIRLS
         * ENABLED_NEWSLETTER_TAILORING
         */
        function getConfiguration() {
            return [
                {
                    name: 'NEWSLETTER_MAN',
                    description: ItxTranslateSvc.translateCms('legacy.common.generic.sectionMen')
                },
                {
                    name: 'NEWSLETTER_WOMAN',
                    description: ItxTranslateSvc.translateCms('legacy.common.generic.sectionWomen')
                }
            ];
        }
        /**
         * @ngdoc method
         * @name subscribe
         * @methodOf common.newsletter.service:ItxNewsletterSvc
         * @description
         *
         * Newsletter subscription.
         * If the function receives an array of sections (MEN, WOMAN, B&G, PERSONAL TAILORING) then it will concatenate the sections
         * separated by a "#".
         * If it receives an empty array or no sections at all, it will send the default `generalNewsletter` type of newsletter in the
         * newsletter parameter.
         * @example
         * Example with sections. JSON subscription object to send to the API.
         * ```
         * data: {
         *          'address': {
         *              'email': 'test@massimodutti.com'
         *          },
         *          'newsletter': 'MAN#WOMAN',
         *          'origin': null,
         *          'privacyPolicyAccepted': true
         *      }
         * ```
         *
         * @param {string} email - User email
         * @param {string} sections - The name of the newsletter the user will subscribe to or the sections selected
         * @param {string} origin - The origin of the request.
         * @param {string} inBackground - Enable popup susbcription catch.
         * @returns {promise} - $q promise
         */
        function subscribe(email, sections, origin, inBackground) {
            var deferred = $q.defer();
            _getNewsletterOrigin().then(function () {
                var action = {
                    action: 'user:subscribeNewsletterRequest',
                    params: {
                        storeId: inditex.iStoreId,
                        languageId: inditex.iLangId
                    },
                    data: {
                        address: {
                            email: email
                        },
                        newsletter: _normalizeSections(sections),
                        newsletterOrigin: _findNewsletterOrigin(origin),
                        privacyPolicyAccepted: true
                    }
                };

                joyr.rest
                    .xRestExecute([action])
                    .done(function () {
                        deferred.resolve();

                        if (inditex.iUserJSON.email) {
                            setTimeout(function () {
                                UserService.getCurrentUser().then(function () {
                                    //Comprobación de VIP para mostrar popup VIP
                                    UserService.isVipEnabled().then(function (enabled) {
                                        if (enabled) {
                                            UserService.showVipModal();
                                        }
                                    });
                                });
                            }, 1000);
                        }
                    })
                    .Catch(function (error) {
                        deferred.reject(error);
                        if (!inBackground) {
                            DialogSvc.open('DynamicError.genericProblem');
                        }
                        imNewsletter.createServerError({ $name: error.errorKey }, error);
                    });
            });
            return deferred.promise;
        }

        function _findNewsletterOrigin(origin) {
            var objOrigin = {};
            if (_this.newsletterOrigins && _this.newsletterOrigins.length > 0) {
                _.forEach(_this.newsletterOrigins, function (el) {
                    if (el.description == origin) {
                        objOrigin.id = el.id;
                        objOrigin.value = el.description;
                    }
                });
                if (!objOrigin.id) {
                    objOrigin = null;
                }
            } else {
                objOrigin = null;
            }
            return objOrigin;
        }

        /**
         * @ngdoc method
         * @name unsubscribe
         * @methodOf common.newsletter.service:ItxNewsletterSvc
         * @description
         * Unsusbcribe an user to the newsletter.
         * @param {string} email - The e-mail address of the user to be unsubscribed.
         * @returns {promise} - $q promise
         */
        function unsubscribe(email) {
            var deferred = $q.defer();

            var action = {
                action: 'user:unsubscribeNewsletterRequest',
                params: {
                    storeId: inditex.iStoreId,
                    languageId: inditex.iLangId,
                    email: email
                }
            };

            joyr.rest
                .xRestExecute([action])
                .done(function () {
                    deferred.resolve();
                    UserService.getCurrentUser();
                })
                .Catch(function (error) {
                    deferred.reject(error);
                    DialogSvc.open(
                        'ItxNewslettersUnsubscribeUnsuccessConfirmView.message',
                        'ItxNewslettersUnsubscribeSuccessConfirmView.title'
                    );
                });

            return deferred.promise;
        }
        /**
         * @ngdoc method
         * @name getStatus
         * @methodOf common.newsletter.service:ItxNewsletterSvc
         * @description
         * Get the newsletter status of an user. This is, whether the user is subscrited to a newsletter or not.
         * The API will return the sections in a string separated by '#' character.
         * In order to be more easy to handle, this function will convert the string to an array of sections.
         * For example:
         * From "MEN#WOMEN" to ['MEN','WOMEN']
         * @param {string} email - The e-mail address of the user.
         * @returns {promise} - $q promise of newsletter sections converted to array. Example: ['MEN','WOMEN']
         */
        function getStatus(email) {
            var deferred = $q.defer();

            var action = {
                action: 'user:newsletterStatus',
                params: {
                    storeId: inditex.iStoreId,
                    languageId: inditex.iLangId,
                    email: email
                }
            };

            joyr.rest
                .xRestExecute([action])
                .done(function (data) {
                    var newsletter =
                        data[0].newsletter.length == 0 ? [] : _.split(data[0].newsletter, '#');
                    deferred.resolve(newsletter);
                })
                .Catch(function (error) {
                    deferred.reject(error);
                });
            return deferred.promise;
        }
        /**
         * @ngdoc method
         * @name updateSections
         * @methodOf common.newsletter.service:ItxNewsletterSvc
         * @description
         * Update sections from newsletter subscription. For example, if user is subscribed to MAN and want to start receiving
         * updates from WOMAN.
         * @param {array} sections - Newsletter sections.
         * @returns {promise} - $q promise
         * @example
         * <pre>
         * data:{
         *  newsletter:"MEN#WOMEN"
         * }
         * </pre>
         */
        function updateSections(sections) {
            var deferred = $q.defer();

            var action = {
                action: 'user:updateNewsletterStatus',
                params: {
                    storeId: inditex.iStoreId,
                    languageId: inditex.iLangId
                },
                data: {
                    newsletter: _normalizeSections(sections)
                }
            };

            joyr.rest
                .xRestExecute([action])
                .done(function () {
                    deferred.resolve();
                })
                .Catch(function (error) {
                    deferred.reject(error);
                    DialogSvc.open('DynamicError.genericProblem');
                });
            return deferred.promise;
        }

        /**
         * @ngdoc method
         * @private
         * @name _normalizeSections
         * @methodOf common.newsletter.service:ItxNewsletterSvc
         * @description
         * Returns the concatenation of the array elements of sections by '#'
         * @param {array} sections  Array of sections
         * @returns {string} sections
         * @example
         * <pre>
         * ['MAN','WOMAN']
         * var sections =  _normalizeSections(['MAN','WOMAN']);
         * // sections: 'MAN#WOMAN'
         * </pre>
         */
        function _normalizeSections(sections) {
            if (!Array.isArray(sections)) {
                //LEGACY
                sections = sections.split('#');
            }
            sections = _.filter(sections, function (section) {
                return _.includes(sectionsAllowed, section);
            });

            if (sections.length > 0) {
                return sections.join('#');
            } else {
                console.error('NO SELECTED SECTIONS FOR SUBSCRIPTION TO NEWSLETTER..')
                return DEFAULT_NEWSLETTER;
            }
        }

        /**
         * @ngdoc method
         * @methodOf common.service:ItxNewsletterSvc
         * @name get
         * @description
         * Devuelve el Json completo de origins
         */
        function _getNewsletterOrigin() {
            var deferred = $q.defer();
            var url =
                'https://' +
                inditex.iProxyHostStandard +
                '/itxrest/2/catalog/store/' +
                inditex.iStoreId +
                '/newsletter-origins';
            if (!_this.newsletterOrigins) {
                $http
                    .get(url + '?' + timestampSvc.getTs())
                    .then(function (res) {
                        if (
                            !res.data.newsletterOrigins &&
                            res.data.newsletterOrigins.length === 0
                        ) {
                            deferred.reject();
                        } else {
                            _this.newsletterOrigins = res.data.newsletterOrigins;
                            deferred.resolve(res.data.newsletterOrigins);
                        }
                    })
                    .catch(function (error) {
                        deferred.reject(error);
                    });
            } else {
                deferred.resolve(_this.newsletterOrigins);
            }
            return deferred.promise;
        }

        /**
         * @ngdoc method
         * @name getSurveyTemplate
         * @methodOf common.newsletter.service:ItxNewsletterSvc
         * @description
         * Devuelve la plantilla de encuestas cuyo nombre es {templateName} para el {storeId}.
         * @param {string} templateName - Template name.
         * @returns {promise} - $q promise
         */
        function getSurveyTemplate(templateName) {
            var deferred = $q.defer();

            const action = {
                action: 'survey:getSurvey',
                params: {
                    storeId: inditex.iStoreId,
                    templateName: templateName
                }
            };

            joyr.rest
                .xRestExecute([action])
                .done(function (data) {
                    deferred.resolve(data);
                })
                .Catch(function (error) {
                    deferred.reject(error);
                    DialogSvc.open('DynamicError.genericProblem');
                });

            return deferred.promise;
        }

        /**
         * @ngdoc method
         * @name sendUnsubscribeNewsletterSurvey
         * @methodOf common.newsletter.service:ItxNewsletterSvc
         * @description
         * Send unsubscribe survey
         * @param {string} templateName
         * @param {object} questions
         * @param {string} email
         * @returns {promise} - $q promise
         */
        function sendUnsubscribeNewsletterSurvey(templateName, questions, email) {
            var deferred = $q.defer();
            _sha256(`SuAn;bajaNewsletter;${inditex.iCountryCode};${email}`).then(function (token) {
                const url = 'https://' + inditex.iProxyHostStandard + '/itxrestservux/2/store/' + inditex.iStoreId + '/survey/' + templateName;

                $http
                    .get(url, {
                        params: {
                            storeId: inditex.iStoreId,
                            templateName: templateName,
                            token,
                            email
                        }
                    })
                    .then(function (response) {
                        if ('etag' in response.headers()) {
                            let etag = response.headers().etag;
                            etag = etag.replaceAll('"', '');
                            _updateSurvey(templateName, token, email, questions, etag)
                                .done(function () {
                                    deferred.resolve();
                                })
                                .Catch(function (error) {
                                    console.log('FALLO PUT: ', error);
                                    if (error.data.error.code === 201) {
                                        deferred.resolve();
                                    } else {
                                        deferred.reject(error);
                                        DialogSvc.open('DynamicError.genericProblem');
                                    }
                                });
                        } else {
                            _addSurvey(templateName, token, email, questions)
                                .done(function () {
                                    deferred.resolve();
                                })
                                .Catch(function (error) {
                                    console.log('FALLO POST: ', error);
                                    deferred.reject(error);
                                    DialogSvc.open('DynamicError.genericProblem');
                                });
                        }
                    })
                    .catch(function (error) {
                        console.log('error: ', error);
                        if (error.data.error.code === 404) {
                            _addSurvey(templateName, token, email, questions)
                                .done(function () {
                                    deferred.resolve();
                                })
                                .Catch(function (error) {
                                    console.log('FALLO POST: ', error);
                                    deferred.reject(error);
                                    DialogSvc.open('DynamicError.genericProblem');
                                });
                        } else {
                            console.log('FALLO GET: ', error);
                            deferred.reject(error);
                            DialogSvc.open('DynamicError.genericProblem');
                        }
                    });
            });
            return deferred.promise;
        }

        function _addSurvey(templateName, token, email, questions) {
            return new joyr.Promise(function (resolve, reject) {
                const unsubscribeNewsletterSurveyAction = {
                    action: 'survey:addSurvey',
                    params: {
                        storeId: inditex.iStoreId,
                        templateName: templateName,
                        token,
                        email
                    },
                    data: questions
                };

                joyr.rest
                    .xRestExecute([unsubscribeNewsletterSurveyAction])
                    .done(function () {
                        resolve();
                    })
                    .Catch(function (error) {
                        reject(error);
                    });
            });
        }

        function _updateSurvey(templateName, token, email, questions, etag) {
            return new joyr.Promise(function (resolve, reject) {
                const url = 'https://' + inditex.iProxyHostStandard + '/itxrestservux/2/store/' + inditex.iStoreId + '/survey/' + templateName;

                $http({
                    method: 'PUT',
                    url,
                    params: {
                        storeId: inditex.iStoreId,
                        templateName: templateName,
                        token,
                        email
                    },
                    headers: {
                        'If-Match': etag
                    },
                    data: questions
                })
                    .then(function () {
                        resolve();
                    })
                    .catch(function (error) {
                        reject(error);
                    });
            });
        }

        function shuffleOptions(options) {
            let result = null;
            const lastIdOption = Object.keys(options).length - 1;
            const optionOther = options[lastIdOption];
            delete options[lastIdOption];
            result = _sortRandom(options);
            result[lastIdOption] = optionOther;
            return result;
        }

        /**
         *
         * @param {*} options
         * @returns object randomly ordered
         */
        function _sortRandom(options) {
            return Object.keys(options)
                .sort(() => Math.random() - 0.5)
                .map((key) => options[key]);
        }

        function _sha256(message) {
            return new joyr.Promise(function (resolve) {
                // encode as UTF-8
                const msgBuffer = new TextEncoder('utf-8').encode(message);
                // hash the message
                crypto.subtle.digest('SHA-256', msgBuffer).then((hashBuffer) => {
                    // convert ArrayBuffer to Array
                    const hashArray = Array.from(new Uint8Array(hashBuffer));
                    // convert bytes to hex string
                    const hashHex = hashArray.map((b) => ('00' + b.toString(16)).slice(-2)).join('');
                    resolve(hashHex);
                });
            });
        }
    }
})();
